module.exports = function (selector) {
  return typeof selector === 'function' ? selector() : selector;
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/resolveSelector.js
 ** module id = 13
 ** module chunks = 0
 **/